module.exports = __webpack_public_path__ + "img/book1.042e91e5.png";